const lensRxPrefix = 'lens';

export const lensEventRoutes = {
  navigationChanged: `${lensRxPrefix}-navigation-changed`,
  sessionStarted: `${lensRxPrefix}-session-started`,
  sessionEnded: `${lensRxPrefix}-session-ended`,
  visitorInfoChanged: `${lensRxPrefix}-visitorInfo-changed`
};
